import type { ButtonComponentProps } from 'components/atoms/Button';
import { Button } from 'components/atoms/Button';
import { Loader } from 'components/atoms/Loader';
import type { FC } from 'react';
import { useState } from 'react';
import { flushSync } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { ONE_SECOND } from 'utils/time';

type SendMeTestEmailProps = Omit<ButtonComponentProps, 'onClick'> & {
  onClick: () => Promise<any>;
};

const SendMeTestEmail: FC<SendMeTestEmailProps> = ({
  onClick,
  disabled,
  ...rest
}) => {
  const { t } = useTranslation();
  const [isSendingEnabled, setIsSendingEnabled] = useState(true);

  const { mutate, isLoading } = useMutation(() => onClick(), {
    onSuccess: () => {
      flushSync(() => setIsSendingEnabled(false));
      setTimeout(() => {
        setIsSendingEnabled(true);
      }, ONE_SECOND * 3);
    },
  });

  return (
    <Button
      structure="text"
      {...rest}
      disabled={isLoading || !isSendingEnabled || disabled}
      onClick={() => mutate()}
    >
      <span className="flex items-center gap-2">
        {isLoading && <Loader />}
        {isSendingEnabled
          ? t('email_client.test_email.submit')
          : t('email_client.test_email.sent')}
      </span>
    </Button>
  );
};

export default SendMeTestEmail;
